
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './Pages/Login/Login';
import RequireAuth from './Components/RequireAuth';
import Missing from './Components/Missing';
import Navbar from './Components/Navbar';
import Home from './Pages/Home/Home';
import { useContext, useEffect } from 'react';
import Logs from './Pages/Logs/Logs';
import Users from './Pages/Users/Users';
import Devices from './Pages/Devices/Devices';
import Business from './Pages/Business/Business';
import { ThemeContext } from './context/ThemeContext';
import ThemeProvider from './theme';
function App() {
  const auth = localStorage.getItem("token");
  const {darkTheme} = useContext(ThemeContext);

  return (
    <div className={`App ${darkTheme ? "darkMode" : "lightMode"}`}>
      {
        auth ? <Navbar/>:""
      }
         <ThemeProvider>
      <Routes>
        <Route path="/" element={!auth ? <Login />: <Navigate to={"/home"}/>} />
        <Route element={<RequireAuth />}>
          <Route path="/home" element={<Home />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/users" element={<Users />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/business" element={<Business />} />
        </Route>
          {/* catch all */}
          <Route path="*" element={<Missing />} />
      </Routes>
      </ThemeProvider>

    </div>
  );
}

export default App;
